import React, { useEffect } from "react";

/* Material UI Components */
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import CircularProgress from "@material-ui/core/CircularProgress";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { Link } from "react-router-dom";

/* Material UI Styles*/
import {
  ThemeProvider,
  withStyles,
  createMuiTheme,
} from "@material-ui/core/styles";
import { makeStyles } from "@material-ui/styles";

/* React Admin */
import {
  TextInput,
  PasswordInput,
  required,
  regex,
  useAuthProvider,
  useNotify,
  useRedirect,
} from "react-admin";

/* React final Form */
import { Form } from "react-final-form";

/* Social Sign In */
import GoogleLogin from "react-google-login";

/* Utils */
import { useRouteState } from "./../../Utils/hooks";

/* Image Assets */
import professionals from "./../../images/signupV2-professionals.svg";

/* Customizing Button */
const SignupV2Button = withStyles({
  root: {
    backgroundColor: "#EF8354",
    color: "#fff",
  },
})(Button);
const OAuthButton = withStyles({
  root: (props) => ({
    color: props.color,
    borderColor: props.color,
  }),
})(Button);

const useStyle = makeStyles({
  leftPanel: {
    height: "100vh",
    backgroundColor: "#EF8354",
  },
  rightPanel: {
    height: "100vh",
  },
  bannerImage: {
    margin: "8%",
    marginTop: "12%",
    width: "40vw",
  },
  bannerHeader: {
    color: "#4F5D75",
    fontWeight: "bold",
  },
  formPaper: {
    width: "25vw",
    height: "75vh",
    margin: "auto",
    marginTop: "5vh",
    padding: "20px",
    borderRadius: "20px",
  },
  formPaperSm: {
    width: "85vw",
    height: "75vh",
    margin: "auto",
    marginTop: "5vh",
    padding: ".3rem",
    borderRadius: "20px",
  },

  verticalN10: {
    margin: "auto",
    marginTop: "-10px",
  },
  vertical0: {
    margin: "auto",
  },
  vertical10: {
    margin: "auto",
    marginTop: "10px",
  },
  vertical20: {
    margin: "auto",
    marginTop: "20px",
  },
  vertical30: {
    margin: "auto",
    paddingTop: "30px",
  },
  avatar: {
    width: "180px",
    height: "180px",
  },
  avatarSm: {
    width: "120px",
    height: "120px",
  },
  field: {
    width: "20vw",
  },
  fieldSm: {
    width: "60vw",
  },
});
const mentorTheme = createMuiTheme({
  palette: {
    primary: {
      main: "#EF8354",
    },
  },
});

const SignUpForm = ({
  handleSubmit,
  reset,
  submitting,
  pristine,
  values,
  signUpGoogle,
  signUpGoogleFailure,
  props,
  ...rest
}) => {
  const classes = useStyle();
  const isDesktop = useMediaQuery(mentorTheme.breakpoints.up("md"));

  //validations
  // eslint-disable-next-line
  const validateEmail = regex(/^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/,
    "Kindly add valid email"
  );

  // eslint-disable-next-line
  const validatePassword = regex(
    /^(?=.*\d)(?=.*[a-z])[\w~@#$%^&*+=`|{}:;!.?"()[\]-]{6,}$/,
    "Password must contain one Small, one Capital letter and should be atleast minimum 6 charachters long"
  );

  const validateConfirmPassword = (values) => (password) =>
    values.Password === password
      ? undefined
      : { message: "Password does not match" };

  return (
    <form onSubmit={handleSubmit}>
      <Grid container direction="column">
        <Grid item>
          <Grid container direction="column">
            <Grid
              item
              className={isDesktop ? classes.vertical30 : classes.vertical0}
            >
              <TextInput
                source="email"
                label="Email"
                variant="outlined"
                className={isDesktop ? classes.field : classes.fieldSm}
                validate={[required(), validateEmail]}
              />
            </Grid>
            <Grid
              item
              className={isDesktop ? classes.vertical20 : classes.vertical0}
            >
              <PasswordInput
                source="Password"
                label="Password"
                variant="outlined"
                className={isDesktop ? classes.field : classes.fieldSm}
                validate={[required(), validatePassword]}
              />
            </Grid>
            <Grid
              item
              className={isDesktop ? classes.vertical10 : classes.vertical0}
            >
              <PasswordInput
                source="ConfirmPassword"
                label="Confirm Password"
                variant="outlined"
                className={isDesktop ? classes.field : classes.fieldSm}
                validate={[required(), validateConfirmPassword(values)]}
              />
            </Grid>
            <Grid
              item
              className={isDesktop ? classes.vertical30 : classes.vertical0}
            >
              <SignupV2Button
                type="submit"
                variant="contained"
                disabled={submitting}
              >
                {submitting ? <CircularProgress size="2rem" /> : "REGISTER"}
              </SignupV2Button>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          className={isDesktop ? classes.vertical30 : classes.vertical10}
        >
          <Typography variant="body2">OR</Typography>
        </Grid>
        <Grid item>
          {isDesktop ? (
            <Grid container direction="column">
              <Grid
                item
                className={isDesktop ? classes.vertical30 : classes.vertical0}
              >
                <GoogleLogin
                  render={(renderProps) => (
                    <OAuthButton
                      variant="outlined"
                      color="#007BA7"
                      style={{ marginRight: "10px" }}
                      onClick={renderProps.onClick}
                      disabled={renderProps.disabled}
                    >
                      {renderProps.disabled ? (
                        <CircularProgress size="2rem" color="#007BA7" />
                      ) : (
                        "GOOGLE SIGN UP"
                      )}
                    </OAuthButton>
                  )}
                  //buttonText="Google Sign Up"
                  clientId="208946399161-7v80irs0uea2pi33rlo2p4onb717j31i.apps.googleusercontent.com"
                  onSuccess={(payload) => signUpGoogle(payload)}
                  onFailure={(e) => {
                    signUpGoogleFailure(e);
                  }}
                />
                <OAuthButton variant="outlined" color="#0E49AF">
                  <a
                    href={`https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${process.env.REACT_APP_LINKEDIN_CLIENT_ID}&redirect_uri=${window.location.href}&scope=r_emailaddress%20r_liteprofile&state=linkedinInLogin`}
                    style={{ textDecoration: "none" }}
                  >
                    LinkedIn Sign Up
                  </a>
                </OAuthButton>
              </Grid>
            </Grid>
          ) : (
            <Grid container direction="column">
              <Grid item className={classes.vertical10}>
                <GoogleLogin
                  render={(renderProps) => (
                    <OAuthButton
                      variant="outlined"
                      color="#007BA7"
                      style={{ marginRight: "10px" }}
                      onClick={renderProps.onClick}
                      disabled={renderProps.disabled}
                    >
                      {" "}
                      Google Sign Up
                    </OAuthButton>
                  )}
                  clientId="208946399161-7v80irs0uea2pi33rlo2p4onb717j31i.apps.googleusercontent.com"
                  onSuccess={(payload) => signUpGoogle(payload)}
                  onFailure={(e) => {
                    signUpGoogleFailure(e);
                  }}
                />
              </Grid>
              <Grid item className={classes.vertical30}>
                <OAuthButton variant="outlined" color="#0E49AF">
                  <a
                    href={`https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${process.env.REACT_APP_LINKEDIN_CLIENT_ID}&redirect_uri=${window.location.href}&scope=r_emailaddress%20r_liteprofile&state=linkedinInLogin`}
                    style={{ textDecoration: "none" }}
                  >
                    LinkedIn Sign Up
                  </a>
                </OAuthButton>
              </Grid>
            </Grid>
          )}
        </Grid>
        <br />
        <Grid
          item
          style={{
            margin: "auto",
          }}
        >
          already have an account ?
          <Link
            to="/login"
            style={{
              textDecoration: "none",
            }}
          >
            {" "}
            log in
          </Link>
        </Grid>
      </Grid>
    </form>
  );
};

const SignupV2 = () => {
  const classes = useStyle();

  const isDesktop = useMediaQuery(mentorTheme.breakpoints.up("md"));

  const authProvider = useAuthProvider();
  const notify = useNotify();
  const redirect = useRedirect();

  const { signUpGoogle } = useAuthProvider();
  const location = useRouteState();
  useEffect(() => {
    if (location.query && location.query.state === "linkedinInLogin") {
      authProvider.signUpLinkedIn({
        code: location.query.code,
        redirect,
        notify,
      });
    }
  }, [authProvider, location, redirect, notify]);

  const handleSubmit = async (values) => {
    const apiCall = await authProvider.signUp({
      ...values,
    });

    const response = JSON.parse(apiCall);

    if (response.code !== 202) {
      await authProvider.login({
        username: values.email,
        password: values.Password,
        redirect: redirect,
        userInfo: true,
        notify: notify,
      });
    } else {
      notify(response.message);
    }
  };

  return (
    <ThemeProvider theme={mentorTheme}>
      {isDesktop ? (
        <Grid container alignItems="stretch">
          <Grid item md={6} className={classes.leftPanel}>
            <img
              alt="Become a 123Mentor"
              src={professionals}
              className={classes.bannerImage}
            />
          </Grid>
          <Grid item md={6} className={classes.rightPanel}>
            <Grid container direction="column">
              <Grid item className={classes.vertical20}>
                <Typography variant="h3" className={classes.bannerHeader}>
                  Become a 123Mentor!
                </Typography>
              </Grid>
              <Grid item>
                <Paper elevation={4} className={classes.formPaper}>
                  <Form
                    onSubmit={handleSubmit}
                    render={SignUpForm}
                    signUpGoogle={async (payload) => {
                      try {
                        await signUpGoogle({ payload, notify, redirect });
                        redirect("/user-info");
                      } catch (e) {
                        notify("Could not Sign Up with Google Sign Up");
                      }
                    }}
                    signUpGoogleFailure={async (e) => {
                      notify("Could not login with Google Sign Up");
                    }}
                  ></Form>
                </Paper>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      ) : (
        <Grid container alignItems="stretch">
          <Grid item sm={12} className={classes.rightPanel}>
            <Grid container direction="column">
              <Grid item className={classes.vertical20}>
                <Typography variant="h4" className={classes.bannerHeader}>
                  Become a 123Mentor!
                </Typography>
              </Grid>
              <Grid item>
                <Paper elevation={4} className={classes.formPaperSm}>
                  <Form
                    onSubmit={handleSubmit}
                    render={SignUpForm}
                    signUpGoogle={async (payload) => {
                      try {
                        await signUpGoogle({ payload, notify, redirect });
                        redirect("/user-info");
                      } catch (e) {
                        console.log(e);
                        notify("Could not Sign Up with Google Sign Up");
                      }
                    }}
                    signUpGoogleFailure={async (e) => {
                      console.log(e);
                      notify("Could not login with Google Sign Up");
                    }}
                  ></Form>
                </Paper>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}
    </ThemeProvider>
  );
};

export default SignupV2;
